import React from 'react';
import { Provider } from 'react-redux';
import PersistedStore from "./PersistedStore"

export default ({ element }) => ( // eslint-disable-line import/no-anonymous-default-export
    <Provider store={PersistedStore.getDefaultStore().store}>{element}</Provider>
);
